import React from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { authenticatedEntry } from "configs/AppConfig";

const PublicRoute = () => {
	const { token } = useSelector((state) => state.auth);

	if (token) {
		return (window.location.href = authenticatedEntry());
	}
	return <Outlet />;
};

export default PublicRoute;
